// extracted by mini-css-extract-plugin
module.exports = {"label":"label__3_FuU","text":"text__2gkRY","select":"select__zXXek","head":"head__3WpYu","archived":"archived__DnQSq"};